var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C8DCE8",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C11.5819 8 8 11.5819 8 16C8 20.4181 11.5819 24 16 24C20.4181 24 24 20.4181 24 16C24 11.5819 20.4181 8 16 8ZM15.0756 19.4532V15.7909C15.0756 15.5458 15.173 15.3106 15.3463 15.1373C15.5197 14.9639 15.7548 14.8665 16 14.8665C16.2452 14.8665 16.4803 14.9639 16.6537 15.1373C16.827 15.3106 16.9244 15.5458 16.9244 15.7909V19.4532C16.9244 19.6983 16.827 19.9335 16.6537 20.1068C16.4803 20.2802 16.2452 20.3776 16 20.3776C15.7548 20.3776 15.5197 20.2802 15.3463 20.1068C15.173 19.9335 15.0756 19.6983 15.0756 19.4532ZM16 13.8578C15.7802 13.8578 15.5654 13.7926 15.3827 13.6705C15.2 13.5484 15.0576 13.3749 14.9735 13.1719C14.8894 12.9688 14.8674 12.7454 14.9102 12.5299C14.9531 12.3144 15.0589 12.1164 15.2143 11.961C15.3697 11.8056 15.5677 11.6998 15.7832 11.6569C15.9988 11.614 16.2222 11.636 16.4252 11.7201C16.6282 11.8042 16.8018 11.9466 16.9239 12.1294C17.0459 12.3121 17.1111 12.5269 17.1111 12.7467C17.1111 13.0414 16.994 13.324 16.7857 13.5323C16.5773 13.7407 16.2947 13.8578 16 13.8578Z",
    fill: "#C8DCE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/General.160caaa4.svg";
export { ForwardRef as ReactComponent };